export default function Footer() {
  return (
    <footer className="border-t border-[var(--color-border)] bg-[var(--color-surface)] px-6 py-4 text-center text-sm text-[var(--color-text-muted)]">
      <p>FinApp — Controle financeiro pessoal</p>
    </footer>
  )
}
